import React, { useState, useEffect } from "react";
import classNames from "classnames/bind";
import styles from "./Map.module.css";
import SideBarMap from "./Sidebar/SideBarMap";
import MapBoxGl from "./MapBox/MapBoxGl";
import ModalLive from "./ModalLive/ModalLive";
import axiosClient from "../../services/axiosClient";
import { MapContext } from "../../contexts";
const cx = classNames.bind(styles);

const Map = () => {
  const [zoom, setZoom] = useState(5);
  const [showLive, setShowLive] = useState(false);
  const [listCameraCode, setListCameraCode] = useState({});
  const [wareCode, setWareCode] = useState();
  const [group, setGroup] = useState();
  const [isGroup, setIsGroup] = useState(false);
  const onClose = () => {
    setShowLive(!showLive);
  };
  // console.log(group);

  return (
    <MapContext.Provider
      value={{
        listCameraCode,
        setListCameraCode,
        wareCode,
        setWareCode,
        group,
        setGroup,
        isGroup,
        setIsGroup,
        zoom,
        setZoom,
      }}
    >
      <div className={cx("map-page")}>
        {showLive && <ModalLive onClose={onClose} />}
        <div className={cx("side-bar")}>
          <SideBarMap />
        </div>
        <div className={cx("map-content")}>
          <MapBoxGl showLive={showLive} setShowLive={setShowLive} />
        </div>
      </div>
    </MapContext.Provider>
  );
};

export default Map;
